import { axiosInstance, fetchInstance } from './interceptor';
import { GetCommonServiceToken, GetAccessApiToken } from "./Util";
import { GetTokenInfo } from "../pages/intakeSheet/assignmentOfBenefit/Service";
import { CallingApp } from '../Constant';

export const CallApiForLoginCheck = (data) => {
  return new Promise((resolve, reject) => {
    post(
      process.env.REACT_APP_LAW_API_URL,
      "Patient/login",
      data
    )
      .then((response) => {
        sessionStorage.setItem("User", JSON.stringify(response.data));
        resolve({
          success: true,
          data: response.data,
          message: response.data.message
        });
      })
      .catch((error) => {
        // Extract error message from API response
        const errorMessage = error?.response?.data?.message || "Login failed";
        
        reject({
          success: false,
          message: errorMessage,
          error
        });
      });
  });
};

export const post = (url, pathParam, data, isSkipLoader = false) => {
    return new Promise((resolve, reject) => {
      callApi();

      function callApi() {
          axiosInstance
            .post(url + pathParam, data, { skipLoader: isSkipLoader })
            .then((response) => {
                return resolve(response);
            })
            .catch((error) => {
                return reject(error);
            });
      }
    });
};

export const Put = (url, data, isSkipLoader = false) => {
    return axiosInstance.put(url , data, { skipLoader: isSkipLoader });
};

export const GetWithCommon = async (url) => {
    let CommonServiceToken = GetCommonServiceToken();
    return await fetchInstance(url, {
        method: "get",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + CommonServiceToken,
        },
    })
};

export const PostWithCommon = async (url, data) => {
    let CommonServiceToken = GetCommonServiceToken();
    return await fetchInstance(url, {
        method: "post",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + CommonServiceToken,
        },
        body: JSON.stringify(data),
    })
};

export const PostWithAccessToken = async (url, data) => {
    let AccessToken = GetAccessApiToken();
    return await fetchInstance(url, {
        method: "post",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + AccessToken,
        },
        body: JSON.stringify(data),
    })
};

export const GetWithAccessToken = async (url) => {
    let AccessToken = GetAccessApiToken();
    return await fetchInstance(url, {

        method: "get",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + AccessToken,
        }
    })
};

export const PostWithReponse = async (url, data) => {
    let TokenInfo = GetTokenInfo();

    return await fetchInstance(url, {

        method: "post",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + TokenInfo.AccessToken,
        },
        body: JSON.stringify(data),
    })
};


export const CallApiForOTPVerification = (data) => {
  return new Promise((resolve, reject) => {
    post(
      `${process.env.REACT_APP_LAW_API_URL}Patient/verify-otp`, '',
      data
    )
      .then((response) => {
        // Always resolve true regardless of patientDetails being null
        resolve({
          success: true,
          data: response.data,
          patientDetails: response.data?.patientDetails || null,
          message: response.data?.message || "OTP verified successfully"
        });
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.message || "OTP verification failed";
        reject({
          success: false,
          message: errorMessage,
          error
        });
      });
  });
};

export const Get = async (url) => {
    return await fetchInstance(url, {
        method: "get",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })
}

export const CallApiForSaveMedicalNotes = (data) => {
  return new Promise((resolve, reject) => {
    post(
      process.env.REACT_APP_LAW_API_URL,
      "MedicalNote/save-medical-notes",
      data
    )
      .then((response) => {
        resolve({
          success: true,
          data: response.data,
          message: response.data.message || "Medical notes saved successfully"
        });
      })
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.message || "Failed to save medical notes";

        reject({
          success: false,
          message: errorMessage,
          error
        });
      });
  });
};

export const CallApiForGetMedicalNoteFields = async () => {
    try {
        const response = await fetchInstance(
            `${process.env.REACT_APP_LAW_API_URL}MedicalNote/medical-note-fields`
        );

        const data = await response.json();

        return {
            success: true,
            data
        };

    } catch (error) {
        return {
            success: false,
            message: error.message
        };
    }
};

export const CallApiForGetPatientMedicalNotes = async (patientId, locationId) => {
  try {
    const response = await fetchInstance(
      `${process.env.REACT_APP_LAW_API_URL}MedicalNote/medical-notes-value/${patientId}/${locationId}`
    );

    const data = await response.json();

    return {
      success: true,
      data
    };

  } catch (error) {
    return {
      success: false,
      message: error.message
    };
  }
};

export const CallApiForUploadDocument = (data) => {
  return new Promise((resolve, reject) => {
    post(
      process.env.REACT_APP_LAW_API_URL,
       "Document/upload-document",
      data                         
    )
      .then((response) => {
        resolve({
          success: true,
          data: response.data.data,
          message: response.data.message || "Document uploaded successfully"
        });
      })
      .catch((error) => {
        reject({
          success: false,
          message: error?.response?.data?.message || "Failed to upload document",
          error
        });
      });
  });
};  
export const CallApiForGetPatientDocuments = async (patientId) => {
  try {
    const response = await fetchInstance(
      `${process.env.REACT_APP_LAW_API_URL}Document/patient-documents/${patientId}`
    );

    const data = await response.json();

    if (data.success) {
      return {
        success: true,
        data: data.data
      };
    } else {
      return {
        success: false,
        message: data.message || "Failed to fetch documents"
      };
    }

  } catch (error) {
    return {
      success: false,
      message: error.message || "Error fetching documents"
    };
  }
};

export const getPatientDetailsByLink = (shortId) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_LAW_API_URL}Patient/patient-details/by-link?shortId=${shortId}`
        // `https://localhost:44301/api/Patient/patient-details/by-link?shortId=${shortId}`,
      )
      .then((response) => {
        resolve({
          success: true,
          data: response.data,
        });
      })
      .catch((error) => {
        reject({
          success: false,
          message:
            error?.response?.data?.message || "Token decryption failed",
          error,
        });
      });
  });
};

export const CallSearchPatientsByContactDetails = (contactData) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(
        `${process.env.REACT_APP_LAW_API_URL}Patient/search-patients-by-contact`, contactData
        // `https://localhost:44301/api/Patient/search-patients-by-contact`, contactData,
      )
      .then((response) => {
        resolve({
          success: true,
          data: response.data,
        });
      })
      .catch((error) => {
        reject({
          success: false,
          message:
            error?.response?.data?.message || "Something went wrong.",
          error,
        });
      });
  });
};

export const CallApiToMarkLinkOpened = (shortId) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(
        `${process.env.REACT_APP_LAW_API_URL}Patient/mark-link-opened?ShortId=${shortId}`,
        // `https://localhost:7092/api/Patient/mark-link-opened?ShortId=${shortId}`,
      )
      .then((response) => {
        resolve({
          success: true,
          data: response.data,
        });
      })
      .catch((error) => {
        reject({
          success: false,
          message:
            error?.response?.data?.message,
          error,
        });
      });
  });
};

export const CallApiForGetLocationListByCaseId = async (caseId, companyId) => {
  try {
    const response = await fetchInstance(
      `${process.env.REACT_APP_LAW_API_URL}Patient/GetLocationListByCaseId?caseId=${encodeURIComponent(caseId)}&companyId=${encodeURIComponent(companyId)}`
    );

    const data = await response.json();

    if (data.success) {
      return {
        success: true,
        data: data.data,
        message: data.message || "Locations fetched successfully"
      };
    } else {
      return {
        success: false,
        message: data.message || "Failed to fetch locations"
      };
    }

  } catch (error) {
    return {
      success: false,
      message: error.message || "Error fetching locations"
    };
  }
};

export const CallApiForDeleteDocument = (documentId) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(`${process.env.REACT_APP_LAW_API_URL}Document/document/${documentId}`)
      .then((response) => {
        resolve({
          success: true,
          message: response.data?.message || "Document deleted successfully"
        });
      })
      .catch((error) => {
        reject({
          success: false,
          message: error?.response?.data?.message || "Failed to delete document",
          error
        });
      });
  });
};

// TODO(backend): `Patient/finalized-visits` does not exist in Gyb.Patient.Backend yet.
export const CallApiForGetFinalizedVisits = async (patientId, companyId, eventIds = []) => {
  try {
    const params = new URLSearchParams({ patientId, companyId });
    if (eventIds.length) params.set("eventIds", eventIds.join(","));
    const response = await fetchInstance(
      // `${process.env.REACT_APP_LAW_API_URL}Patient/get-finalized-visits?${params.toString()}`,
      `${process.env.REACT_APP_LAW_API_URL}Patient/get-finalized-visits?${params.toString()}`,
      //  `https://localhost:44301/api/Patient/get-finalized-visits?${params.toString()}`,

      { headers: { Env: process.env.REACT_APP_ENVIRONMENT } }
    );
    const data = await response.json();
    return data.success
      ? { success: true, data: data.data || [], message: data.message }
      : { success: false, message: data.message || "Failed to fetch finalized visits" };
  } catch (error) {
    return { success: false, message: error.message || "Error fetching finalized visits" };
  }
};

export const CallApiForGetCaseDocuments = async (caseId) => {
  try {
    const response = await fetchInstance(
      `${process.env.REACT_APP_LAW_API_URL}Document/case-documents/${encodeURIComponent(caseId)}`,
      {headers: { Env: process.env.REACT_APP_ENVIRONMENT }}
    );

    // const response = await fetchInstance(
    //   `https://localhost:7092/api/Document/case-documents/${encodeURIComponent(caseId)}`
    // );
    const data = await response.json();

    if (data.success) {
      return {
        success: true,
        data: data.data,
        message: data.message || "Documents fetched successfully"
      };
    } else {
      return {
        success: false,
        message: data.message || "Failed to fetch case documents"
      };
    }

  } catch (error) {
    return {
      success: false,
      message: error.message || "Error fetching case documents"
    };
  }
};

export const getUserIp = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');

    if (!response.ok) throw new Error(`HTTP error: ${response.status}`);

    const { ip } = await response.json();

    if (ip) sessionStorage.setItem('UserIp', ip);

    return ip;
  } catch (error) {
    console.error('Failed to fetch user IP:', error);
    return null;
  }
};

export const getBrowserInfo = () => {
  const agent = navigator.userAgent.toLowerCase();

  const browsers = [
    { name: 'edge',                match: () => agent.includes('edge') },
    { name: 'chromium based edge', match: () => agent.includes('edg') },
    { name: 'opera',               match: () => agent.includes('opr') && !!window.opr },
    { name: 'chrome',              match: () => agent.includes('chrome') && !!window.chrome },
    { name: 'ie',                  match: () => agent.includes('trident') },
    { name: 'firefox',             match: () => agent.includes('firefox') },
    { name: 'safari',              match: () => agent.includes('safari') },
  ];

  const browser = browsers.find(({ match }) => match())?.name ?? 'other';
  sessionStorage.setItem('Browser', browser);
  return browser;
};



export const PostAndGetFileInResponse = async (url, data) => {
    let TokenInfo = GetTokenInfo();
    return await fetch(url, {
        method: "post",
        headers: {
            // Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + TokenInfo.AccessToken,
            CallingApp: CallingApp,
        },
        responseType: "blob",
        body: JSON.stringify(data),
    })
}
